import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-352f4906"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-2" }
const _hoisted_2 = { class: "text-sm capitalize font-[600]" }
const _hoisted_3 = ["value", "required"]
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "capitalize" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.label.replace(/_/g, " ")) + " " + _toDisplayString(_ctx.required ? "*" : ""), 1),
    _createElementVNode("input", {
      type: "text",
      value: _ctx.checked,
      required: _ctx.required,
      class: "cursor-default w-[1px] h-[1px] opacity-0",
      autocomplete: "false",
      readonly: ""
    }, null, 8, _hoisted_3),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "flex items-center space-x-2"
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          value: option,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checked) = $event)),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateValue && _ctx.updateValue(...args))),
          class: "text-blue-500 rounded focus:ring-blue-500 focus:border-blue-500"
        }, null, 40, _hoisted_4), [
          [_vModelCheckbox, _ctx.checked]
        ]),
        _createElementVNode("span", _hoisted_5, _toDisplayString(option), 1)
      ]))
    }), 128))
  ]))
}